// 存储键名常量
export const STORAGE_KEYS = {
    ACTIVE_MENU: 'bidderActiveMenu',
    USER_PREFERENCES: 'bidderUserPreferences'
}

// 路由路径常量
export const ROUTE_PATHS = {
    LOGIN: '/login',
    TODO_LIST: '/bidderHome/todoList',
    BIDDER_HOME: '/bidderHome'
}

// 菜单配置常量
export const MENU_CONFIG = [
    {
        index: '0',
        title: '投标管理',
        icon: 'el-icon-s-order',
        children: [
            { index: '1-1', title: '报名/参与项目', route: '/bidderHome/registration' },
            { index: '1-2', title: '报名情况查看', route: '/bidderHome/registrationStatus' },
            // { index: '1-3', title: '上传投标文件', route: '/bidderHome/uploadBid' },
            { index: '1-4', title: '邀请招标', route: '/bidderHome/inviteBidding' },
            { index: '1-5', title: '邀请招标-标书购买', route: '/bidderHome/inviteBiddingPurchase' },
            { index: '1-6', title: '我的订单', route: '/bidderHome/myOrders' },
            { index: '1-7', title: '我的项目', route: '/bidderHome/myPurchaseProjects' }
        ]
    },
 
    {
        index: '2',
        title: '系统管理',
        icon: 'el-icon-setting',
        children: [
            { index: '2-1', title: '组织机构修改', route: '/bidderHome/organizationModify' },
            // { index: '2-3', title: '修改密码', route: '/bidderHome/changePassword' },
            // { index: '2-4', title: '用户信息修改', route: '/bidderHome/userInfoModify' },
            // { index: '2-5', title: '信用查询(CA)', route: '/bidderHome/creditQuery' }
        ]
    },
    {
        index: '3',
        title: 'ca管理',
        icon: 'el-icon-s-goods',
        children: [
            { index: '3-1', title: 'CA授权管理', route: '/bidderHome/caManagement' }
        ]
    }
]

// 用户命令类型
export const USER_COMMANDS = {
    LOGOUT: 'logout',
    PROFILE: 'profile',
    SETTINGS: 'settings'
}

// 面包屑配置常量
export const BREADCRUMB_CONFIG = {
    '/bidderHome/todoList': [
        { title: '首页', route: '/bidderHome' },
        { title: '待办列表', route: null }
    ],
    '/bidderHome/registration': [
        { title: '首页', route: '/bidderHome' },
        { title: '投标管理', route: null },
        { title: '报名/参与项目', route: null }
    ],
    '/bidderHome/registrationStatus': [
        { title: '首页', route: '/bidderHome' },
        { title: '投标管理', route: null },
        { title: '报名情况查看', route: null }
    ],
    '/bidderHome/uploadBid': [
        { title: '首页', route: '/bidderHome' },
        { title: '投标管理', route: null },
        { title: '上传投标文件', route: null }
    ],
    '/bidderHome/inviteBidding': [
        { title: '首页', route: '/bidderHome' },
        { title: '投标管理', route: null },
        { title: '邀请招标', route: null }
    ],
    '/bidderHome/inviteBiddingPurchase': [
        { title: '首页', route: '/bidderHome' },
        { title: '投标管理', route: null },
        { title: '邀请招标-标书购买', route: null }
    ],
    '/bidderHome/myOrders': [
        { title: '首页', route: '/bidderHome' },
        { title: '投标管理', route: null },
        { title: '我的订单', route: null }
    ],
    '/bidderHome/myPurchaseProjects': [
        { title: '首页', route: '/bidderHome' },
        { title: '投标管理', route: null },
        { title: '我的项目', route: null }
    ],
    '/bidderHome/organizationModify': [
        { title: '首页', route: '/bidderHome' },
        { title: '系统管理', route: null },
        { title: '组织机构修改', route: null }
    ],
    '/bidderHome/changePassword': [
        { title: '首页', route: '/bidderHome' },
        { title: '系统管理', route: null },
        { title: '修改密码', route: null }
    ],
    '/bidderHome/userInfoModify': [
        { title: '首页', route: '/bidderHome' },
        { title: '系统管理', route: null },
        { title: '用户信息修改', route: null }
    ],
    '/bidderHome/creditQuery': [
        { title: '首页', route: '/bidderHome' },
        { title: '系统管理', route: null },
        { title: '信用查询(CA)', route: null }
    ],
    '/bidderHome/bidderFlow': [
        { title: '首页', route: '/bidderHome' },
        { title: '投标管理', route: null },
        { title: '我的项目', route: '/bidderHome/myPurchaseProjects' },
        { title: '投标人流程', route: null }
    ],
     '/bidderHome/caManagement': [
        { title: '首页', route: '/bidderHome' },
        { title: 'ca管理', route: null },
        { title: 'CA授权管理', route: null }
    ]
}

// 投标人流程子页面标题映射：path → 显示名称（动态生成五级面包屑用）
export const BIDDER_SUB_PAGE_TITLE_MAP = {
    '/bidderHome/downloadTender':      '下载招标文件',
    '/bidderHome/bidClarification':    '文件澄清与修改',
    '/bidderHome/technologyFee':       '缴纳技术服务费',
    '/bidderHome/bidDocument':         '响应文件',
    '/bidderHome/confirmBidRecord':    '确认投标记录',
    '/bidderHome/answerJudges':        '解答评委疑问',
    '/bidderHome/viewWinBids':         '查看中标公告',
    '/bidderHome/bidSecondQuotate':    '二次报价',
    '/bidderHome/makeBidDocument':     '制作投标文件',
    '/bidderHome/raiseAQuestion':      '提出对文件的质疑',
    '/bidderHome/checkNotice':         '中标公告',
    '/bidderHome/bidNoticeSuccessful': '中标结果通知书',
    '/bidderHome/objectionManagement': '异议管理'
}

// 默认面包屑
export const DEFAULT_BREADCRUMB = [
    { title: '首页', route: '/bidderHome' },
    { title: '当前页面', route: null }
]
